export var PreferenceType;
(function (PreferenceType) {
    PreferenceType["EMAIL"] = "EMAIL";
    PreferenceType["PHONE"] = "PHONE";
    PreferenceType["SMS"] = "SMS";
    PreferenceType["DIRECT_MAIL"] = "MAIL";
    PreferenceType["PRIVACY"] = "PRIVACY";
})(PreferenceType || (PreferenceType = {}));
export var PrivacySettings;
(function (PrivacySettings) {
    PrivacySettings["ON"] = "on";
    PrivacySettings["OFF"] = "off";
})(PrivacySettings || (PrivacySettings = {}));
